import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { closeLicense } from '../actions.js';

// The actual MIT license text (https://opensource.org/license/mit),
// year/copyright holder filled in per feature-ui.md's explicit values —
// this is a real license notice, not placeholder copy (unlike terms.js,
// which is explicitly marked as placeholder legal text).
const MIT_LICENSE_BODY = `Copyright (c) 2026 Kingscot OU

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.`;

export function renderLicenseModal() {
  const s = getState();
  if (!s.showLicense) return null;

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, 'MIT License'),
      h('div', { class: 'text-sm text-muted stack-tight license-body' },
        MIT_LICENSE_BODY.split('\n\n').map((p) => h('p', {}, p))),
      h('button', { class: 'btn btn-secondary', onclick: closeLicense }, 'Close')
    ])
  ]);
}
